export type HttpHeaders = {
    "twbrds-api-version"?: string
    "twbrds-account-id"?: string
    "twbrds-session"?: string
    "twbrds-user-role"?: string
    "twbrds-organization-id"?: string
    "figure-api-key"?: string
}

export const OperationType = {
    Insert: "insert",
    Update: "update",
    Delete: "delete",
}

export const RecordTypeEnum = {
    Category: "category",
    CategoryGroup: "category_group",
    CategoryGroupItem: "category_group_item",
    CategoryGroupItemDetail: "category_group_item_detail",
    CategoryHasCategoryGroup: "category_to_category_group",
    CategoryLocation: "category_location",
    CategoryGroupLocation: "category_group_location",
    CategoryGroupItemLocation: "category_group_item_location",
    CategoryGroupItemDetailLocation: "category_group_item_detail_location",
    CategoryImage: "category_image",
    SchematizedLayoutTile: "schematized_layout_tile",
    SchematizedLayoutGrid: "schematized_layout_grid",
    Tax: "tax",
    Assignment: "assignment",
    Location: "location",
    Terminal: "terminal",
    CategoryTaxOld: "category_tax",
    CategoryTaxOldLocation: "category_tax_location",
    Pricing: "special_pricing",
    CategoryPricing: "category_special_pricing",
    CategoryPricingLocation: "category_special_pricing_location",
    Customer: "customer",
    CustomerAddress: "customer_address",
    TimeRecord: "time_record",
    Department: "department",
    Role: "role",
    User: "user",
    UserAccount: "user_account",
    UserAccountAddress: "user_account_address",
    UserAccountLocation: "user_account_location",
    UserAccountNote: "user_account_note",
    UserAccountRole: "user_account_role",
    AccessLevel: "access_level",
    Permission: "permission",
    Setting: "setting",
    LoyaltyProgram: "loyalty_program",
    CustomerLoyaltyProgram: "customer_loyalty_program",
    SalesInputFolder: "sales_input_folder",
    SalesInputItem: "sales_input_item",
    KioskSalesInputItem: "kiosk_sales_input_item",
    KioskSalesInputFolder: "kiosk_sales_input_folder",
    InventoryItem: "inventory_item",
    InventoryItemLocation: "inventory_item_location",
    InventoryItemTransaction: "inventory_item_transaction",
    AccountImage: "account_image",
}

export type RecordType = (typeof RecordTypeEnum)[keyof typeof RecordTypeEnum]
